<template>
  <div class="canvas__wrapper world">
    <div :id="name" class="test">
      <!--<div v-on:click="leaveSite()" class="leave__site">Position Speichern</div>
      <div v-on:click="toggleCamera()" class="camera__toggle">Camera Toggeln</div> -->
    </div>
    <div class="loading__overlay text-center" v-if="loading < 100 && !started">
      <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide mb-5">
      <h2 class="font-black color--red mb-5"><span class="font-black"  v-html="$t('WORLD02_LOADING01')">Loading<br>Ueno Park<br></span><br>{{ loading }}%</h2>
      <p class="font-black" v-html="$t('WORLD02_LOADING02')">« Prepare for arrival »</p>
    </div>

    <div class="loading__overlay loading__overlay--start" v-if="loading == 100 && !started" v-bind:class="{fadeout: started}">
      <div class="container">
        <div class="row mb-lg-10 mb-3">
          <div class="col-12">
            <h1 class="font-black" v-html="$t('WORLD02_LOADING03')">Ueno Park</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-3">
            <img src="@/assets/global/Miyuki_dori.png" class="img-fluid">
          </div>
          <div class="col-12 col-md-7 offset-md-1 color--red">
            <p v-html="$t('WORLD02_LOADING04')">"Ueno Park is one of the most iconic parks in Tokyo. During springtime, you can admire the wonderful cherry trees in bloom, immortalised every year by tourists coming from all
              over the world.</p>
            <p v-html="$t('WORLD02_LOADING05')">
              Nature has always been an important source of inspiration for Shiseido, because it is a treasure that has to be nurtured and preserved. As a matter of fact, nature’s beauty is
              appreciated and revered in every moment.
            </p>
            <p v-html="$t('WORLD02_LOADING06')">
              A beauty that is timeless, diverse and ever-changing: just like the cherry trees evolving during all the seasons.
            </p>
            <p v-html="$t('WORLD02_LOADING07')">
              In this module you will discover 4 famous buildings: Kaneji Temple, National Museum, Kabuki Theatre and the Pagoda.
              Make sure to click on this buildings to discover more information and an iconic Shiseido product"
            </p>
            <p class="mt-4 btn btn-red text-uppercase" v-on:click="started = !started" v-html="$t('WORLD01_LOADING06')">Let's start</p>
          </div>
        </div>
      </div>

    </div>


    <MobileWorldNavigation></MobileWorldNavigation>
  </div>
</template>

<script>
import $ from 'jquery';
import MobileWorldNavigation from "@/components/MobileWorldNavigation";

export default {
  name: 'World',
  components: {MobileWorldNavigation},
  props: {
    msg: Object,
    name: String,
    overlayOpen: Boolean,
    quiz: Boolean,
    overlayStatus: Array
  },
  data() {
    return {
      started: false,
      renderer: "",
      scene: "",
      c: "",
      currentC: 1,
      loader: "",
      loading: 0,
      gltf: "",
      showQuiz: false,
      keyPresed: false,
      destroyFunc: Function,
      useOrbitCamera: false,
      three: Object,
      checkmarks: [],
      cameraSpeed: {
        x: 10,
        y: 10
      }
    }
  },
  methods: {
    leaveSite() {
      window.localStorage.removeItem('cameraState');
      const cameraState = JSON.stringify(this.c.matrix.toArray());
      window.localStorage.setItem('cameraState', cameraState);
      alert('Position wurde gespeichert.\nBitte Seite neu Laden!')
    },
    setCameraState(camera) {
      let cameraState = JSON.parse(window.localStorage.getItem('cameraState'));

      if (cameraState != null) {


        camera.matrix.fromArray(cameraState);
        camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
      } else {
        camera.position.set(100, -1000, 1000);
      }
    },
    setUpRenderer(renderer) {
      renderer.setSize(window.innerWidth, window.innerHeight);
      var container = document.getElementById(this.name);
      container.appendChild(renderer.domElement);
    },
    toggleCamera() {
    },
    createStats() {
      const Stats = require('stats-js')
      var stats = new Stats();
      stats.setMode(0);

      stats.domElement.style.position = 'absolute';
      stats.domElement.style.left = '0';
      stats.domElement.style.top = '0';

      return stats;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.THREE = require('three');

    const THREELoader = require("three/examples/jsm/loaders/GLTFLoader");
    const THREEHelper = require("three/examples/jsm/helpers/RectAreaLightHelper");
    const THREEDracoLoader = require("three/examples/jsm/loaders/DRACOLoader");
    const THREEColladaLoader = require("three/examples/jsm/loaders/ColladaLoader");
    const THREEControls = require("three/examples/jsm/controls/OrbitControls");
    const THREEObjLoader = require("three/examples/jsm/loaders/OBJLoader");
    const THREEWater = require('three/examples/jsm/objects/Water.js');
    const THREESky = require('three/examples/jsm/objects/Sky.js');
    this.three = THREE;
    let _this = this;
    let animationID = 0;

    let keyboard = {};
    const mouse = new THREE.Vector2();
    const target = new THREE.Vector2();
    const windowHalf = new THREE.Vector2(window.innerWidth / 2, window.innerHeight / 2);
    let quizIcon;


    function keyDown(event) {
      keyboard[event.keyCode] = true;
    }

    function keyUp(event) {
      delete keyboard[event.keyCode];
    }

    function onMouseMove(event) {
      if (_this.started) {

        let validEvent = true;
        if (event.target.classList) {
          if (event.target.classList.contains('arrow__wrapper') || event.target.classList.contains('img-fluid')) {
            validEvent = false;
          }

        }
        if (_this.overlayOpen == true) {
          validEvent = false;
        }
        if (validEvent) {
          mouse.x = (event.clientX - windowHalf.x);
          mouse.y = (event.clientY - windowHalf.y);
        }

      }
    }


    // Setup Basic stuff
    let loader = new THREELoader.GLTFLoader();

    let scene = new THREE.Scene();
    window.scene = scene;
    scene.background = new THREE.Color(0xa6cee1);
    let renderer = new THREE.WebGLRenderer({antialias: true, premultipliedAlpha: false, stencil: false, powerPreference: "high-performance"});
    //let camera = new THREE.PerspectiveCamera( 1000, window.innerWidth/window.innerHeight, 0.1, 10000 );
    let camera2 = new THREE.PerspectiveCamera(1000, window.innerWidth / window.innerHeight, 0.1, 10000);
    let camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.01, 1000);
    this.c = camera;
    camera.rotation.order = "YXZ";

    camera.rotation.z = 180;
    /*
    let stats = this.createStats();
    document.body.appendChild(stats.domElement);
     */
    camera2.position.set(4, -8, 1);
    camera.name = "Camera";
    scene.add(camera)
    scene.add(camera2)

    renderer.shadowMap.enabled = true;
    //renderer.physicallyCorrectLights = false;
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 1.6;
    //renderer.setSize(window.innerWidth,window.innerHeight);

    let hemiLight = new THREE.HemisphereLight(0xffead5, 0xab790d, 0.5);
    hemiLight.position.set(0, -800, 0);
    hemiLight.name = "hemilight";
    scene.add(hemiLight);
    let amiLight = new THREE.AmbientLight(0xffead5, 0.35);
    amiLight.position.set(0, -800, 0);
    amiLight.name = "amilight";
    scene.add(amiLight);

    let light = new THREE.SpotLight(0xffead5, 0.5);
    light.position.set(-400, -1200, 0);
    light.castShadow = true;
    scene.add(light);
    light.shadow.bias = -0.0001;
    light.shadow.mapSize.width = 1024;
    light.shadow.mapSize.height = 1024;
    let light2 = new THREE.SpotLight(0xffead5, 0.5);
    light2.position.set(0, -1200, -400);
    light2.castShadow = true;
    //scene.add( light2 );

    var light3 = new THREE.DirectionalLight(0xffead5, 0.66);
    light3.position.set(0, -100, 0); 			//default; light shining from top
    light3.castShadow = true;            // default false
    scene.add(light3);


    // Setup Controls
    let controls = new THREEControls.OrbitControls(camera, renderer.domElement);
    let controls2 = new THREEControls.OrbitControls(camera2, renderer.domElement);
    controls.update();
    controls2.update();

    this.setUpRenderer(renderer);
    renderer.setPixelRatio(window.devicePixelRatio);
    let ta = "test";
    window.addEventListener('keydown', keyDown, true);
    window.addEventListener('keyup', keyUp, true);
    document.addEventListener('mousemove', onMouseMove, true);
    let spl = [];
    var spline;
    // Detect CameraState and set it if valid
    this.setCameraState(camera);
    let colladaLoader = new THREEColladaLoader.ColladaLoader();
    var quaternion = new THREE.Quaternion();
    quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), 11.01);

    let urlSpline;
    if (process.env.NODE_ENV == 'development') {
      urlSpline = "/world_02_spline-new.dae";
    } else {
      //urlSpline = "/Module/Tokyo/world_02_spline.dae";
      urlSpline = "/Module/Tokyo/world_02_spline-new.dae";
    }

    colladaLoader.load(urlSpline, function (collada) {
      let s = collada.scene.children[0].geometry.attributes.position.array;
      for (let i = 3; i < s.length; i += 3) {

        let x = s[i - 1];
        let y = (s[i - 2] * -1) - 50;
        let z = s[i];
        let tempX = x * -1;
        if (x < 383 && x > 370) {
          //y = -50;
        }
        let v = new THREE.Vector3(x, y, z);
        v.applyQuaternion(quaternion);

        spl.push(v);
      }

      var material = new THREE.LineBasicMaterial({color: 0x0000ff});
      var geometry = new THREE.BufferGeometry().setFromPoints(spl);
      var l = new THREE.Line(geometry, material);
      l.name = "LIne";


      //scene.add( l );
      l.applyQuaternion(quaternion);
      l.position.set.z = -65;
      l.position.set.x = 20;
      l.position.set.y = 10;
      l.rotation.set.y = 11;

      let tspline = new THREE.CatmullRomCurve3(spl);
      let splinePoints = tspline.getSpacedPoints(150);
      spline = new THREE.CatmullRomCurve3(splinePoints)

    });


// Create the final object to add to the scene
    window.addEventListener('resize', onWindowResize, false);

    function onWindowResize() {

      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);

    }

    // Setup Scene Stuff
    //scene.background = new THREE.Color(0xFFFFFF);
    let dracoLoader = new THREEDracoLoader.DRACOLoader();
    dracoLoader.setDecoderPath('examples/js/libs/draco/');
    loader.setDRACOLoader(dracoLoader);


    let raycaster = new THREE.Raycaster();

    renderer.domElement.addEventListener('click', raycast, false);
    renderer.domElement.addEventListener('touchstart', raycastMobile, false);

    function raycast(e) {

      //1. sets the mouse position with a coordinate system where the center
      //   of the screen is the origin
      let centerMx = (e.clientX / window.innerWidth) * 2 - 1;
      let centerMy = -(e.clientY / window.innerHeight) * 2 + 1;
      //mouse.x = ( e.clientX / window.innerWidth ) * 2 - 1;
      //mouse.y = - ( e.clientY / window.innerHeight ) * 2 + 1;
      let m = new THREE.Vector2(centerMx, centerMy);

      //2. set the picking ray from the camera position and mouse coordinates
      raycaster.setFromCamera(m, camera);

      //3. compute intersections
      var intersects = raycaster.intersectObjects(scene.children[6].children, true);

      for (var i = 0; i < 1; i++) {
        if (intersects[i].object) {
          let el = intersects[i].object;
          while (el.parent) {
            if (el.parent.name == 'world') {
              if (el.name == "Museum" || el.name == "Ueno_Tosho_Gu" || el.name == "pagode" || el.name == "Theater" || el.name == "quiz") {
                if (el.name == "quiz") {
                  _this.$router.push({name: 'pages', params: {kapitel: '02', pageid: '020-start'}});
                  break;
                } else {
                  let selector = el.name;
                  el.traverse(function (child) {
                    if (child.name == "checked") {
                      child.visible = true;
                    }
                    if (child.name == "unchecked") {
                      child.visible = false;
                    }
                  });
                  _this.$emit('toggleOverlay', selector);
                  break;
                }

              } else {
                let tempEl = el;
                el = tempEl.parent;
              }
            } else {
              let tempEl = el;
              el = tempEl.parent;
            }
          }
        }
      }

    }

    function raycastMobile(e) {

      //1. sets the mouse position with a coordinate system where the center
      //   of the screen is the origin
      let centerMx = (e.touches[0].clientX / window.innerWidth) * 2 - 1;
      let centerMy = -(e.touches[0].clientY / window.innerHeight) * 2 + 1;
      //mouse.x = ( e.clientX / window.innerWidth ) * 2 - 1;
      //mouse.y = - ( e.clientY / window.innerHeight ) * 2 + 1;
      let m = new THREE.Vector2(centerMx, centerMy);

      //2. set the picking ray from the camera position and mouse coordinates
      raycaster.setFromCamera(m, camera);

      //3. compute intersections
      var intersects = raycaster.intersectObjects(scene.children[6].children, true);

      for (var i = 0; i < 1; i++) {
        if (intersects[i].object) {
          let el = intersects[i].object;
          while (el.parent) {
            if (el.parent.name == 'world') {
              if (el.name == "Museum" || el.name == "Ueno_Tosho_Gu" || el.name == "pagode" || el.name == "Theater" || el.name == "quiz") {
                if (el.name == "quiz") {
                  _this.$router.push({name: 'pages', params: {kapitel: '02', pageid: '020-start'}});
                  break;
                } else {
                  let selector = el.name;
                  el.traverse(function (child) {
                    if (child.name == "checked") {
                      child.visible = true;
                    }
                    if (child.name == "unchecked") {
                      child.visible = false;
                    }
                  });
                  _this.$emit('toggleOverlay', selector);
                  break;
                }

              } else {
                let tempEl = el;
                el = tempEl.parent;
              }
            } else {
              let tempEl = el;
              el = tempEl.parent;
            }
          }
        }
      }

    }

    let url;
    if (process.env.NODE_ENV == 'development') {
      url = "/world_2.gltf";
    } else {
      url = "/Module/Tokyo/world_2.gltf";
    }

    loader.load(
        url,
        function (gltf) {
          let world = gltf.scene;
          world.traverse(function (child) {
            // Code for Child detection => Clickable Objects
            if (child.name == "quiz") {
              quizIcon = child;
              child.visible = false;
            }
            if (child.name == "water") {
              child.material.opacity = 0.9;
              child.material.color.setRGB(0.25, 0.5, 0.8);
            }
            if (child.name == "checked") {
              _this.checkmarks.push(child);
              child.visible = false;
            }
            if (child instanceof THREE.Mesh) {

              if (child.material.name != "stone" && child.name != "boden" && child.name != "water" && child.name != "bridge1" && child.name != "bridge") {
                child.castShadow = true;
                child.receiveShadow = true;
              } else {
                child.receiveShadow = true;
              }
              child.matrixAutoUpdate = false;
              child.updateMatrix();
              child.material.side = THREE.FrontSide;
              child.material.metalness = 0;
              child.material.needsUpdate = true;
              if (child.material.map) child.material.map.anisotropy = 1;
            }

          });

          world.rotation.z = Math.PI;
          world.position.set(0, 0, 0);
          world.name = "world";
          scene.add(world);
          _this.gltf = world;
          world.castShadow = true;
          for (let i = 0; i < _this.overlayStatus.length; i++) {
            if(_this.overlayStatus[i]){
              console.log(_this.checkmarks[i])
              console.log(_this.checkmarks[i].parent)
              _this.checkmarks[i].parent.children[0].visible = false;
              _this.checkmarks[i].visible = true;
            }
          }
          animate();
        },
        function (xhr) {
          _this.loading = (xhr.loaded / xhr.total * 100).toFixed(2);

        },
        function (error) {
          console.log('An error happened:', error);
        }
    )

    let destroyed = false;
    this.destroyFunc = function () {

      destroyed = true;
      // Setup Basic stuff
      dracoLoader.dispose();
      loader.setDRACOLoader(null);
      loader = null;
      scene.dispose();
      renderer.forceContextLoss()
      renderer.domElement = null
      renderer.dispose();
      renderer = null
      camera = null;
      controls.dispose();
      this.c = null;
      this.renderer = null;
      this.scene = null;
      this.c = null;
      this.currentC = null;
      this.loader = null;
      this.gltf = null;
      this.three = null;


    }
    let t = 0;
    let camPosIndex = 0;
    let steps = 1500;
    camera.rotation.x = 0;
    let max = 1500;

    function animate() {
      if (!destroyed) {
        setTimeout(function () {

          animationID = requestAnimationFrame(animate);
          if (_this.overlayOpen == false) {
            if (!_this.showQuiz) {
              if (_this.quiz == true) {
                _this.showQuiz = true;
                quizIcon.visible = true;
              }
            }
            handleKeyboardInput(keyboard)

            controls.update();
            //controls2.update();


            //camPosIndex++;
            if (camPosIndex > max) {
              camPosIndex = 0;
            }
            if (camPosIndex < 0) {
              let temp = camPosIndex
              camPosIndex = max - temp;
            }

            var camPos = spline.getPoint(camPosIndex / steps);
            var camRot = spline.getTangent(camPosIndex / steps);
            controls.target.set(camPos.x / 100, -50 / 100, camPos.z / 100)
            if (camPos.x / 100 != camera.position.x) {
              camera.position.x = camPos.x / 100;
            }
            if (camera.rotation.z != Math.PI) {

              camera.rotation.z = Math.PI;
            }


            camera.position.z = camPos.z / 100;
            camera.position.y = camPos.y / 100;

            //camera.rotation.z = Math.PI;

            target.x = (1 + mouse.x) * 0.02;
            target.y = (1 + mouse.y) * 0.02;
            //et c = camera.rotation.x;
            let mouseVal = (mouse.y) / window.innerHeight;
            //light.position.set( camera.position.x, -1200, camera.position.z);
            let val = 0.09;
            camera.rotation.x = val + mouseVal;
            camera.rotation.y += 0.5 * (target.x);
            render();
          }

        }, 1000 / 250);


      }

      // stats.update();
    }

    function render() {
      renderer.render(scene, _this.useOrbitCamera == true ? camera2 : camera);
    }

    function handleKeyboardInput(camera) {

      // Keyboard movement inputs
      if (keyboard[87] || keyboard[38]) { // A key
        // Redirect motion by 90 degrees
        camPosIndex++;
      }
      if (keyboard[83] || keyboard[40]) { // D key
        camPosIndex--;
      }
      if (keyboard[32]) { // D key
        _this.useOrbitCamera = !_this.useOrbitCamera;
      }
    }
  },
  destroyed() {
    this.destroyFunc()
  }
}
</script>

<style scoped lang="scss">
#canvas {
  position: relative;
}

.leave__site {
  position: absolute;
  top: 20px;
  left: 50%;
  cursor: pointer;
  transform: translate(-50%, 0);
}

.camera__toggle {
  position: absolute;
  top: 40px;
  left: 50%;
  cursor: pointer;
  transform: translate(-50%, 0);
}

</style>
